import * as Styled from '../styled';
import React from 'react';
import { TableCell } from '@leasequery/lq.react-component-library/dist/components/table';

interface LastStickyCellProps {
  cell: TableCell;
}

const buildLastStickyCell = (CellComponent?: React.ComponentType) => (
  props: object,
): JSX.Element => (
  <Styled.RightShadowBorder>
    {CellComponent ? (
      <CellComponent {...props} />
    ) : (
      (props as LastStickyCellProps).cell.value
    )}
  </Styled.RightShadowBorder>
);

export { buildLastStickyCell };
